/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".smaller[_ngcontent-%COMP%] {\n  font-size: 65%;\n  font-weight: 400; }\n\n.add-button-text[_ngcontent-%COMP%] {\n  background-color: #dde3f2;\n  color: #252525;\n  font-size: 14px;\n  font-weight: bold; }\n\n.add-button-text-container[_ngcontent-%COMP%] {\n  background-color: #dde3f2; }\n\n.card[_ngcontent-%COMP%] {\n  margin-bottom: 1%; }"];
export { styles as styles };
